// Hook do tworzenia modułu DevStudio

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IPostModuleRequest {
  name: string;
}

const postModule = (data: IPostModuleRequest): Promise<void> =>
  axios.post('/panel/dev-studio/modules', data);

export const usePostModule = (
  options?: UseMutationOptions<void, IError, IPostModuleRequest>
) => useMutation<void, IError, IPostModuleRequest>(postModule, options);
